<template>
  <transition name="modal-fade">
    <div @click="close(false)" v-if="open" class="modal-overlay z-50">
      <div :class="[width === 'small' ? 'small': 'medium']" class="modal-content w-full p-8 pb-8 mx-auto my-0 md:my-10">
        <slot></slot>
        <button @click="close(true)" class="close text-gray-900 text-xl absolute top-0 right-0 p-4 leading-none font-bold focus:outline-none"><i class="fas fa-times"></i></button>
      </div>
    </div>
  </transition>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import {MODAL} from "@/store/types/modules";
import {SET_ID} from "@/store/types/mutations";

export default {
  props: {
    slideId: Number,
    width: {
      type: String,
      default: 'small'
    },
    clickToClose: {
      type: Boolean,
      default: true
    }
  },
  methods: {

    ...mapMutations(MODAL, {
      setActiveId: SET_ID,
    }),
    close(fromCloseButton) {
      if (!fromCloseButton && !this.clickToClose)
        return;

      this.activeId = null;
    },
  },
  computed: {
    ...mapState(MODAL, {
      getActiveId: 'id',
    }),
    activeId: {
      get() {
        return this.getActiveId
      },
      set(value) {
        this.setActiveId(value)
      },
    },
    open() {
      return this.getActiveId === this.slideId
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  left: 0;
  top: 0;
  background-color: rgb(0, 0, 0); /* Black fallback color */
  background-color: rgba(0, 0, 0, 0.7); /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
}

.modal-content {
  position: relative;
  background-color: #fff;

}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;

  .modal-content {
    transform: translateY(20px);
  }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity .5s ease;

  .modal-content {
    transition: transform 0.5s ease;
  }
}

.small {
  @screen md {
    @apply w-3/4;
  }
  @screen lg {
    @apply w-1/3;
  }
}

.medium {
  @screen md {
    @apply w-2/3;
  }
}
</style>